import React from "react";

import { lumCalc } from "../../utils/functions/lumCalc";

function TryAgainLogo(props) {
  const bgColor = props.bgColor;

  return (
    <svg width="11" height="21" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.45 21.8247L2.32495 11.6997L12.45 1.57471" stroke={lumCalc(bgColor) > 128 ? "black" : "white"}/>
    </svg>
    
  );
}

export default TryAgainLogo;
